<a href="#" [matMenuTriggerFor]="menu" onclick="return false">
  <i *ngIf="icon" class="material-icons">{{ icon }}</i>
  {{ name }}
  <i class="material-icons nav-menu__dropdown">arrow_drop_down</i>
</a>
<mat-menu #menu="matMenu" [class]="'brn-menu'">
  <button
    *ngIf="user && (user.role === 'admin' || user.role === 'subadmin')"
    mat-menu-item
    [matMenuTriggerFor]="menuAdmin"
  >
    <mat-icon>settings</mat-icon>
    <span>Admin</span>
  </button>
  <a
    *ngIf="user && user.role === 'admin'"
    [href]="portalSettings.url + '/stats-all'"
    mat-menu-item
  >
    <mat-icon>donut_large</mat-icon>
    <span>Global statistics</span>
  </a>
  <a href="https://brn.ai/docs/" mat-menu-item>
    <mat-icon>help_outline</mat-icon>
    <span>Docs</span>
  </a>
</mat-menu>
<mat-menu #menuAdmin="matMenu" [class]="'brn-menu'">
  <a
    *ngIf="user && (user.role === 'admin' || user.role === 'subadmin')"
    [href]="portalSettings.url + '/admin/bots'"
    mat-menu-item
  >
    <mat-icon>face</mat-icon>
    <span>Bots</span>
  </a>
  <a
    *ngIf="user && (user.role === 'admin' || user.role === 'subadmin')"
    [href]="portalSettings.url + '/users'"
    mat-menu-item
  >
    <mat-icon>person</mat-icon>
    <span>Users</span>
  </a>
  <a
    *ngIf="user && (user.role === 'admin' || user.role === 'subadmin')"
    [href]="portalSettings.url + '/portals'"
    mat-menu-item
  >
    <mat-icon>work</mat-icon>
    <span>Portals</span>
  </a>
  <a
    *ngIf="user && user.role === 'admin'"
    [href]="portalSettings.url + '/mails'"
    mat-menu-item
  >
    <mat-icon>email</mat-icon>
    <span>Mails</span>
  </a>
  <a
    *ngIf="user && user.role === 'admin'"
    [href]="portalSettings.url + '/translation/all'"
    mat-menu-item
  >
    <mat-icon>language</mat-icon>
    <span>Translations</span>
  </a>
  <a
    *ngIf="user && user.role === 'admin'"
    [href]="portalSettings.url + '/admin/content'"
    mat-menu-item
  >
    <mat-icon>poll</mat-icon>
    <span>Content</span>
  </a>
  <a
    *ngIf="user && user.role === 'admin'"
    [href]="portalSettings.url + '/admin/proxies'"
    mat-menu-item
  >
    <mat-icon>vpn_lock</mat-icon>
    <span>Proxies</span>
  </a>
  <a
    *ngIf="user && user.role === 'admin'"
    [href]="portalSettings.url + '/crm-statistic'"
    mat-menu-item
  >
    <mat-icon>person</mat-icon>
    <span>Statistic</span>
  </a>
  <a
    *ngIf="user && user.role === 'admin'"
    [href]="portalSettings.url + '/companies'"
    mat-menu-item
  >
    <mat-icon>group_work</mat-icon>
    <span>Projects</span>
  </a>
  <a
    *ngIf="user && user.role === 'admin'"
    [href]="portalSettings.url + '/members'"
    mat-menu-item
  >
    <mat-icon>group</mat-icon>
    <span>Team</span>
  </a>
  <a
    *ngIf="user && (user.role === 'admin' || user.role === 'subadmin')"
    [href]="portalSettings.url + '/hints'"
    mat-menu-item
  >
    <mat-icon>help</mat-icon>
    <span>Hints</span>
  </a>
</mat-menu>
